import Mutations from '../../odata/mutations';

export default { ...new Mutations('question'), ...new Mutations('questions') };
